import React from 'react';

const ProductSymbol = () => {
	return (
		<>
			<div className="product-symbol">X</div>
		</>
	);
};

export default ProductSymbol;
